import type {
  FilterPreset,
  Filters,
  SnapshotId,
  TableColumnSort,
  TableEndpoint,
  TableSettings,
} from '@ipfabric/utils';
import {
  ApiTableView,
  type ApiTableViewProps,
} from 'components/ApiTable/components/ApiTableView';
import type { ApiTableOuterStateProps } from 'components/ApiTable/model/ApiTableModel';
import { useApiTable } from 'components/ApiTable/model/useApiTable';
import type { TableCellContext } from 'components/Table/model/TableCellContext';
import type {
  TableBulkAction,
  TableRowIdValue,
} from 'components/Table/model/TableModel';
import type { JSX, ReactNode } from 'react';

export interface ApiTableProps
  extends ApiTableViewProps,
    ApiTableOuterStateProps {
  bulkActions?: TableBulkAction[];
  description?: ReactNode;
  disableViewUrl?: boolean;
  endpoint: TableEndpoint<any>;
  externalSettings?: TableSettings;
  initialFilterPreset?: FilterPreset;
  initialFilters?: Filters;
  initialSelectedRows?: TableRowIdValue[];
  initialSort?: TableColumnSort;
  noDataBox?: ReactNode;
  onFiltersSubmit?: (filters: Filters) => void;
  showOnlyIntentResultsOnColumns?: string[];
  snapshotId?: SnapshotId | null;
  staticFilters?: Filters;
  tableCellContext?: Partial<TableCellContext>;
  temporarySettings?: boolean;
  titleEndAdornment?: ReactNode;
}

export const ApiTable = (props: ApiTableProps): JSX.Element => {
  const model = useApiTable({
    bindVariables: props.bindVariables,
    bulkActions: props.bulkActions,
    dataPatch: props.dataPatch,
    description: props.description,
    enableIntentEditor: props.enableIntentEditor,
    enableTableReports: props.enableTableReports,
    disableTableRowDetail: props.disableTableRowDetail,
    disableViewUrl: props.disableViewUrl,
    endpoint: props.endpoint,
    externalSettings: props.externalSettings,
    id: props.id,
    initialFilterPreset: props.initialFilterPreset,
    initialFilters: props.initialFilters,
    initialSelectedRows: props.initialSelectedRows,
    initialSort: props.initialSort,
    loading: props.loading,
    noDataBox: props.noDataBox,
    onFiltersSubmit: props.onFiltersSubmit,
    patchRow: props.patchRow,
    renderCustomApiDoc: props.renderCustomApiDoc,
    rowIdField: props.rowIdField,
    rowSelectionFilter: props.rowSelectionFilter,
    showOnlyIntentResultsOnColumns: props.showOnlyIntentResultsOnColumns,
    snapshotId: props.snapshotId,
    staticFilters: props.staticFilters,
    tableCellContext: props.tableCellContext,
    tableDescription: props.tableDescription,
    tableRowDetailContainer: props.tableRowDetailContainer,
    temporarySettings: props.temporarySettings,
    titleEndAdornment: props.titleEndAdornment,
    menuItems: props.menuItems,
  });

  return (
    <ApiTableView
      model={model}
      borderless={props.borderless}
      className={props.className}
    />
  );
};
